module.exports = __webpack_public_path__ + "static/bk-2079297b61d8555e46f698589520c151.png";